<div class="mb-2">
  <div class="switch">
    <label>
      <input
        type="checkbox"
        [(ngModel)]="activity.model.allowCancel"
      />
      Allow Cancel Inspection Appointment
    </label>
  </div>

  <div class="switch mt-2">
    <label>
      <input
        type="checkbox"
        [(ngModel)]="activity.model.allowBypass"
      />
      Allow Bypass Inspection
    </label>
  </div>
  <span *ngIf="activity.model.allowBypass" class="text-warning">
    Please confirm that the workflow design is configured to handle the new COMPLETE_APPROVE value of "Bypass".
  </span>
</div>

<wm-form-activity-editor
  [activity]="activity"
  [form]="form"
  [workflow]="workflow"
  (saved)="saved.emit($event)"
></wm-form-activity-editor>
